function changeBackgroundHeight() {
	const lpContent = document.querySelector(".lp_content_half-left"),
		lpBackground = document.querySelector(".lp_background"),
		lpCarousel = document.querySelector(".carousel"),
		lpWrapper = document.querySelector(".lp_wrapper");

	if (!lpContent || !lpBackground || !lpWrapper) return;

	const lpWrapperHeight = lpWrapper.clientHeight;

	if (window.innerWidth > 767 && window.innerHeight >= 500) {
		if (window.innerWidth < 1200) {
			lpBackground.style.height = lpWrapperHeight - 35 + "px";
		} else if (window.innerWidth >= 1200) {
			lpBackground.style.height = lpWrapperHeight - 50 + "px";
		}

		if (lpCarousel && window.innerWidth >= 1200 && window.innerHeight < 900) {
			lpBackground.style.height = "";
			lpBackground.classList.add("height");
		}
	} else {
		lpBackground.style.height = lpContent.offsetHeight + "px";
	}
}

export default changeBackgroundHeight;
